module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Freienwil-4dbebbd97a45e44ba668458f7ec1696a.svg";